import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import img from '../../assets/logo-icon.svg';
import Button from '../Button';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const wrongUserStyles = makeStyles(theme => ({
  text: {
    width: '100%',
    padding: '1rem 0',
  },
  buttons: {
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    width: '100%',
    padding: '1rem 0',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      width: '100%',
    },
  },
  button: {
    marginRight: '1rem',
  },
}));

const WrongUserType = ({onClose, correctUserType}) => {
  const classes = wrongUserStyles();
  const wrongUserType = (correctUserType === 'provider') ? 'participant' : 'provider';
  return (
    <React.Fragment>
      <Typography variant="h2" color="primary" className={classes.title}>
        Ooops! You need to be logged in as a {correctUserType} to do this.
      </Typography>
      <Typography variant="body2" className={classes.text}>
        If you&apos;d like to continue, please log out of your {wrongUserType} account. Then log back in using your {correctUserType} account.
      </Typography>
      <div className={classes.buttons}>
        <Button variant="outlined" label="Back to page" cssStyle="large" pointer="none" aria-label="Back to page" onClick={onClose}  className={classes.button}/>
        <Button variant="contained" label="Log me out" cssStyle="large" aria-label="Logout button" to="/logout"  className={classes.button}/>
      </div>
    </React.Fragment>
  );
};

WrongUserType.propTypes = {
  onClose: PropTypes.func.isRequired,
  correctUserType: PropTypes.string,
};

const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiDialogTitle-root .MuiTypography-root': {
      fontSize: '1.5rem',
      fontWeight: 500,
    },
  },
  closeButton: {
    border: '1px solid transparent',
    '&:hover': {
      border: `1px solid ${theme.palette.common.tealish}`,
    },
  },
  content: {
    minWidth: '60vw',
    display: 'flex',
    flexWrap: 'wrap',
    padding: '0.5rem 0',
    backgroundColor: theme.palette.common.white,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  container: {
    width: '100%',
    padding: '1rem 2rem 2.7rem 2.7rem',
  },
  footer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  title: {
    width: '100%',
    backgroundColor: theme.palette.common.white,
    padding: '2.7rem 2rem 0 2.7rem',
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  img: {
    width: '3rem',
    display: 'block',
    position: 'absolute',
    bottom: 25,
    right: 30,
  },
}));

const DialogueBase = ({open, onClose, title='', isWrongUserType=false, correctUserType, children, ...props}) => {
  const classes = useStyles();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Dialog
      open={open}
      maxWidth="lg"
      fullScreen={mobile}
      className={classes.root}
      {...props}
    >
      <DialogTitle className={classes.title} disableTypography>
        <Typography variant="h3" color="primary">
          {title}
        </Typography>
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon color="primary" />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <div className={classes.container}>
          {isWrongUserType ? (
            <WrongUserType onClose={onClose} correctUserType={correctUserType} />
          ) : (
            <React.Fragment>
              {children}
            </React.Fragment>
          )}
          <img src={img} alt="clickability-icon" className={classes.img} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

DialogueBase.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  title: PropTypes.string,
  isWrongUserType: PropTypes.bool,
  correctUserType: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default DialogueBase;
